import { render, staticRenderFns } from "./CharButton.vue?vue&type=template&id=3e777923&scoped=true"
import script from "./CharButton.vue?vue&type=script&lang=js"
export * from "./CharButton.vue?vue&type=script&lang=js"
import style0 from "./CharButton.vue?vue&type=style&index=0&id=3e777923&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e777923",
  null
  
)

export default component.exports